import axios from 'axios';

import { addQueryParams, buildEndpoint, getAuthToken } from '@services/service';
import { PaginatedQuery } from '@app-types/paginated-query.type';

type QueryParams = {
    code?: string;
    type?: number;
    issueDate?: string;
    expiresAt?: string;
} & PaginatedQuery;

const BASE_URL = process.env.REACT_APP_PAYMENTS_URL as string;

const getCoupons = async (params?: QueryParams): Promise<any> => {
    try {
        const queryParams = addQueryParams(params);
        const url = buildEndpoint(BASE_URL, '/api/v1/coupons');
        const response = await axios.get(`${url}${queryParams}`, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data.data;
    } catch (err) {
        return null;
    }
};

export { getCoupons };
